/* eslint-disable */
// 去哪儿用户登录逻辑
import { Sniff } from './q_sniff'
import { mpUtils } from '@tujia/fe-lib-bridge'

const hysdk = window.hysdk
// 小程序环境同步一下q cookies
// if (Sniff.miniprogram) {
//   try {
//     hysdk.ready(() => {
//       hysdk.getUserInfo({
//         success: (info) => {
//           if (info && info.data) {
//             hysdk.syncLoginFromTouch();
//           }
//         },
//         fail: (err) => {
//         }
//       })
//     })
//   } catch (e) { }
// }

const checkLogin = () => {
  return new Promise((resolve, reject) => {
    hysdk.ready((res) => {
      hysdk.checkLogin({
        success: function(data) {
            // data: {ret: true, login: true, state: 2}
            // state: 2 为登录， 1 为登录失效， 0 为未登录
            if (data && data.ret) {
              return resolve(data.state)
            }
            return reject()
        },
        fail: () => { return reject() }
      })
    })
  })
}

// 废弃！！！
const queryUserinfo = (forceLogin = false) => {
  // 2秒登陆超时
  let timer = null
  let didTimeout = false
  const abortPromise = new Promise((resolve, reject) => {
    timer = setTimeout(() => {
      didTimeout = true
      return reject({ errMsg: 'LoginTimeout' })
    }, 2000)
  })
  const loginPromise = new Promise((resolve, reject) => {
    // 小程序登录,单独处理
    if (Sniff.miniprogram) {
      checkLogin().then((res) => {
        if (res === 2) {
          return resolve()
        } else {
          const _clientHref = `${window.location.href}`
          mpUtils.redirectTo({
            url: `/pages/platform/login/index?successUrl=${encodeURIComponent(_clientHref)}`
          })
          return
        }
      })
    }

    hysdk.ready((res) => {
      hysdk.getUserInfo({
        success: (info) => {
          if (info.ret && info.data) {
            return resolve()
          }
          //不强制登陆或者已经超时则直接reject不走登陆逻辑
          if (!forceLogin || didTimeout) return reject()
          //用户操作时间会计入promise时间 需要登陆则移除超时promise
          timer && clearTimeout(timer)
          const loginParam = {
            success: (res) => {
              Sniff.updateUinfo()
              return resolve()
              
            },
            fail: (err) => {
              return reject('需要登录')
            }
          }
          // app端登录
          if (Sniff.qunar) {
            hysdk.login({
              ...loginParam,
              shouldOpenLogin: true
            })
            return
          }
          // 使用ucAPI处理touch端登录
          window.scrollTo(0, 0)
          const instance = window.ucAPI.loginDialog.createInstance(loginParam)
          instance.instanceFunc.showDialog()
          // bug hack  用户点击登录dialog遮罩导致loading提示不消失的bug
          let elm_ucDialog = document.getElementsByClassName('ucApiDialog-dialog')[0]
          let elm_ucDialogContent = document.getElementsByClassName('ucApiDialog-content')[0]
          elm_ucDialog.addEventListener('touchstart', (e) => {
            if (e.target === elm_ucDialog || e.target === elm_ucDialogContent) {
              reject('需要登录')
            }
          })
        },
        fail: (err) => {
          reject(err)
        }
      })
    })
  })
  return Promise.race([loginPromise, abortPromise])
}

// 获取用户信息
const getUserInfo = () => new Promise((resolve) => {
  window.hysdk.ready(() => {
    window.hysdk.getUserInfo({
      success(data) {
        if (data && data.ret) {
          resolve(data.data)
        } else {
          resolve()
        }
      },
      fail: resolve
    })
  })
})

// Q三端登录
const loginQ = () => new Promise((resolve, reject) => {
  window.hysdk.checkLogin({
    success: ({ state }) => {
      if (state === 2) {
        resolve()
      } else {
        if (Sniff.miniprogram) {
          // 微信小程序端登录
          mpUtils.redirectTo({
            url: `/pages/platform/login/index?successUrl=${encodeURIComponent(window.location.href)}`
          })
        } else {
          const loginParam = {
            success: () => {
              Sniff.updateUinfo()
              setTimeout(() => {
                window.location.reload()
              }, 200)
            },
            fail: () => {
              return reject('需要登录')
            }
          }
          if (Sniff.qunar) {
            window.hysdk.login({
              ...loginParam,
              shouldOpenLogin: true
            })
          } else {
            // 使用ucAPI处理touch端登录
            window.scrollTo(0, 0)
            const instance = window.ucAPI.loginDialog.createInstance(loginParam)
            instance.instanceFunc.showDialog()
            // bug hack  用户点击登录dialog遮罩导致loading提示不消失的bug
            let elm_ucDialog = document.getElementsByClassName('ucApiDialog-dialog')[0]
            let elm_ucDialogContent = document.getElementsByClassName('ucApiDialog-content')[0]
            elm_ucDialog.addEventListener('touchstart', (e) => {
              if (e.target === elm_ucDialog || e.target === elm_ucDialogContent) {
                reject('需要登录')
              }
            })
          }
        }
      }
    }
  })
})


export {
  // queryUserinfo,
  // getUserInfo,
  // checkLogin,
  loginQ
}
